import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BaseUserService } from '../../services/base-user/base-user.service';
import { Router } from '@angular/router';

/**
 * A component to request a password reset
 */
@Component({
  selector: 'lm-request-password-reset',
  templateUrl: './request-password-reset.component.html',
  styleUrls: ['./request-password-reset.component.scss']
})
export class RequestPasswordResetComponent implements OnInit {
  /** The component's formgroup */
  public requestPasswordResetForm: FormGroup;

  /**
   * Constructor
   * @param formBuilder - A reference to the formbuild service
   * @param userService - A reference to the user service
   * @param matSnackBar - A reference to the MatSnackBar service
   * @param router - A reference to the router
   */
  constructor(
    private formBuilder: FormBuilder,
    private userService: BaseUserService,
    private matSnackBar: MatSnackBar,
    private router: Router
  ) {}

  /**
   * Method called when the component is initialized
   */
  public ngOnInit() {
    this.requestPasswordResetForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  /**
   * Method called when the user clicks submit
   */
  public async onSubmit() {
    const email: string = this.requestPasswordResetForm.get('email').value;
    await this.userService._requestPasswordReset(email);
    this.matSnackBar.open('An email has been sent with further instructions');
    this.requestPasswordResetForm.reset();
    const delay = ms => new Promise(res => setTimeout(res, ms));
    await delay(3000);
    this.router.navigate(['/']);
  }
}
